export default __webpack_public_path__ + "static/img-credit-score-benefit--mobile-a256f3ac0d3999aedb2de2f75cb5209d.jpg";